import { createSlice } from '@reduxjs/toolkit';

import { ACTION_PLAN_TAB_CONSTANTS } from 'common/constants/TaxonomyConstants';

import type { PayloadAction } from '@reduxjs/toolkit';

const { TAB_MAPPING } = ACTION_PLAN_TAB_CONSTANTS;

export interface IMappingDataCommonState {
	tabIndex: string;
	taxonomyDetailsTabIndex: string;
	selectedTask: string | null;
	grammarCheckCompleted: boolean;
	isImpactUpdated: boolean;
	selectedTabValue: string;
}

const initialState: IMappingDataCommonState = {
	tabIndex: 'overview',
	taxonomyDetailsTabIndex: 'overview',
	selectedTask: null,
	grammarCheckCompleted: false,
	isImpactUpdated: false,
	selectedTabValue: TAB_MAPPING,
};

export const mappingDetailsSlice = createSlice({
	name: 'mappingdetails',
	initialState,
	reducers: {
		setTabIndex: (state, action: PayloadAction<string>) => {
			state.tabIndex = action?.payload;
		},
		setTaxonomyDetailsTabIndex: (state, action: PayloadAction<string>) => {
			state.taxonomyDetailsTabIndex = action?.payload;
		},
		setSelectedTask: (state, action: PayloadAction<string>) => {
			state.selectedTask = action?.payload;
		},
		setGrammarCheckCompleted: (state, action: PayloadAction<boolean>) => {
			state.grammarCheckCompleted = action?.payload;
		},
		setIsImpactUpdated: (state, action: PayloadAction<boolean>) => {
			state.isImpactUpdated = action?.payload;
		},
		setSelectedTabValue: (state, action: PayloadAction<string>) => {
			state.selectedTabValue = action?.payload;
		},
	},
});

export const {
	setTabIndex,
	setTaxonomyDetailsTabIndex,
	setSelectedTask,
	setGrammarCheckCompleted,
	setIsImpactUpdated,
	setSelectedTabValue,
} = mappingDetailsSlice.actions;

export default mappingDetailsSlice.reducer;
